import { render, staticRenderFns } from "./ScheduleDetailsContainer.vue?vue&type=template&id=6533a550"
import script from "./ScheduleDetailsContainer.vue?vue&type=script&lang=js"
export * from "./ScheduleDetailsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports